<div class="form-frequent-container container-fluid">
  <div class="d-flex justify-content-center">
    <div class="total-step-width">
      <div class="fw-bold title">
        {{ 'wizard.alert-name' | translate | uppercase }}
        <span class="asterisk" [hidden]="name && name.length > 1">*</span>
      </div>
      <div class="alert-name-input-field-container">
        <input
          id="alert-name-input-field"
          data-cy="frequent-step-create-alert-name-input-field"
          type="text"
          placeholder="{{ 'wizard.alert-name' | translate }}"
          [(ngModel)]="name"
          (ngModelChange)="onNameChange()"
          autocomplete="off"
        />
      </div>
      <div [hidden]="isNameUnique" class="name-uniqueness-error">
        <div class="d-table">
          <div class="img d-table-cell align-middle align-items-center">
            <img class="d-table-cell align-middle align-items-center" src="/assets/images/icon-alert-triangle.svg" alt="icon-error" />
          </div>
          <div class="text d-table-cell align-middle align-items-center">{{ 'wizard.alert-name-error' | translate }}</div>
        </div>
      </div>
      <div [hidden]="!isNameUnique" class="name-uniqueness-error-empty-space"></div>
      <div class="fw-bold sub-title">{{ 'wizard.which-days' | translate | uppercase }}</div>
      <div class="reception-days-container">
        <digest-week-days-selector class="d-flex" [days]="days" (daySelected)="onSelectDay($event)" />

        <div class="d-flex justify-content-center">
          <div class="info-section total-step-width">
            <div class="d-flex">
              <img src="assets/images/icon-info.svg" alt="icon-info" />
              <div class="fw-bold">{{ 'wizard.frequent-info-title' | translate }}</div>
            </div>
            <div class="text">{{ 'wizard.frequent-info-text' | translate }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
